import { ReactNode } from "react";

import { SelectSignalRBridge } from "./SelectSignalRBridge";

type DataLoaderProps = {
  children: ReactNode;
};

/**
 * Wires the SignalR → React Query invalidation bridge. Selects are now
 * fetched on demand by their consumers via `useSelectFields` /
 * `useExtendedSelectQuery`, so there is no boot-time prefetch or loading
 * screen.
 */
export const DataLoader = ({ children }: DataLoaderProps) => (
  <SelectSignalRBridge>{children}</SelectSignalRBridge>
);
